<template>
  <Page style="padding-top: 80px">
    <Article
      ref="article"
      :title="article.title"
      :title-image="article.titleImage"
      :time="article.formattedTime"
      :summary-text="article.summary"
    >
      <!-- 正文 -->
      <Title size="3"> 权威双认证：铸就行业公信力 </Title>
      <Section
        :image="require('../../../assets/information/article_11_1.webp')"
      >
      </Section>
      <Section>
        CMA（检验检测机构资质认定）：作为国家强制性计量认证，CMA的通过意味着本平台出具的相关数据及报告具有法律证明效力，可作为司法鉴定、工程验收及政府监管的权威依据，为用户业务合规性提供了坚实保障。
        <br />

        CNAS（中国合格评定国家认可委员会）：CNAS认可代表了国际互认的通行证。本次通过认证，表明我司的数字化综合管理平台在技术能力、管理水平及检测流程上，不仅符合中国国家标准，更等效于国际实验室认可合作组织（ILAC）互认协议下60余个国家和地区的认可标准。
        <br />

        在评审过程中，专家组对平台进行了涵盖功能性、性能效率、兼容性、易用性、可靠性及信息安全性在内的全维度现场测试与盲样比对，平台各项指标均100%符合或优于检测标准。
      </Section>
      <Title size="3"> 平台3大核心创新</Title>
      <Section
        :image="require('../../../assets/information/article_11_2.webp')"
      >
      </Section>
      <Title size="3"> ❶ 业务架构完整 </Title>
      <Section>
        突破了传统的数字化管理系统的单点业务功能的局限，实现了一体化的业务架构，打通了从销售、采购、生产、库存、质量、设备、能耗、供应链等管理模块，构建起覆盖全业务场景的统一领域数据模型，建立起从源头到终端的连续可追溯的标准数据流，消除业务领域的数据孤岛。
      </Section>
      <Section
        :image="require('../../../assets/information/article_11_3.webp')"
      >
      </Section>
      <Title size="3">❷ 自动化智能化</Title>
      <Section
        >在统一的领域数据模型与标准数据流的基础上，内置实现了一系列的自动化智能化算法，如业务流自动派单算法、APS智能动态排产算法、动态实时库存跟踪算法等，极大降低了系统操作用户的学习和使用门槛。</Section
      >
      <Title size="3">❸ 部署架构简单灵活</Title>
      <Section
        >采用一体化集成组件架构，可单机/集群部署，同时支持云上部署/本地化部署，满足多样化的IT运维需要。
      </Section>
      <Title size="3">❹ 低成本、高性能处理架构</Title>
      <Section
        >采用高性能海量数据处理架构，内置集成高性能应用中间件与NoSQL存储引擎，可在低成本常规硬件上单机部署。性能较传统架构系统提升1
        倍以上，成本降低了60% 以上。</Section
      >
      <Title size="3">❺ 交互界简洁美观</Title>
      <Section
        >不同于传统的基于页面跳转的交互模式，本系统采用最新的HTML5前端技术栈和富客户端架构，实现UI界面无刷新极速响应。采用响应式、扁平化、互联网化的交互模式，统一的设计风格，降低操作者的学习门槛，提升操作体验。</Section
      >
      <Title size="3">❻ 扩展性强</Title>
      <Section
        >采用模块化分层架构和基于元数据的领域模型驱动设计，提供低代码开发扩展框架和丰富灵活的
        RESTFUL API库。
      </Section>
      <Title size="3">展望未来</Title>
      <Section
        :image="require('../../../assets/information/article_11_4.webp')"
      >
      </Section>
      <Section>
        通过CMA与CNAS双认证，是对新一代数字化综合管理平台技术实力与质量水平的高度认可，更是平台迈向更高成熟度的重要里程碑。<br />

        以此为基石，我们将持续深化平台能力建设：<br />

        ★夯实技术底座：围绕云原生、大数据、AI三大核心引擎，持续提升平台在高并发、多场景下的稳定性和抗压能力；<br />

        ★拓展应用边界：将双认证所验证的可靠能力，延伸至智慧政务、数字能源、智能制造等更多垂直领域；<br />

        ★筑牢质量防线：严格遵循国家级实验室认可规范，确保平台每一次数据输出都经得起法律检验与国际互认。<br />

        以认证为鉴，以品质为锚。我们将持续打磨新一代数字化综合管理平台，使其成为客户数字化转型进程中值得托付的核心引擎。<br />
      </Section>
    </Article>
  </Page>
</template>
<script>
//------------------------------------------------------------------------------
/**
 * 定义文章的简要信息；这些信息将会共享给“新闻资讯”页面用于组装为资讯列表；
 */
import { createArticle } from "../../../components/article-template/article-header.js";

// 文章封面图需要直接导入；
import TITLE_IMAGE from "../../../assets/information/article_2_1.png";

// 创建不包含正文的文章头部；
const ARTICLE_HEADER = createArticle({
  title: "喜报：我司数字化平台通过CMA和CNAS双重认证",
  time: { year: 2026, month: 4, day: 2 },
  titleImage: TITLE_IMAGE,
  summary:
    "近日，我司自主研发的新一代数字化综合管理平台，迎来了发展历程中的又一重要里程碑。该平台已经顺利通过了中国计量认证（CMA）与中国合格评定国家认可委员（CNAS）的双重权威检测认证，这标志着该平台在数据准确性、系统稳定性、法律效力以及国际互认性方面均达到了国家级实验室认可的高标准。",
});

//------------------------------------------------------------------------------

export default {
  name: "Article-1",

  header: ARTICLE_HEADER,

  data() {
    return {
      article: ARTICLE_HEADER,
    };
  },
};
</script>
<style lang="less" scoped></style>
